import { render, staticRenderFns } from "./AdminOrderManageDetailDialog.vue?vue&type=template&id=45e5d56a&"
import script from "./AdminOrderManageDetailDialog.vue?vue&type=script&lang=js&"
export * from "./AdminOrderManageDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrderManageDetailDialog.vue?vue&type=style&index=0&id=45e5d56a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports